import { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { MobileTabBar, MobileTopBar } from './MobileNav';
import { useAuthStore } from '../../stores/authStore';
import { useAppStore } from '../../stores/appStore';
import { clsx } from 'clsx';

export function AppLayout() {
  const { user, loading } = useAuthStore();
  const { sidebarCollapsed } = useAppStore();
  const [menuOpen, setMenuOpen] = useState(false);

  // Lock body scroll while the mobile drawer is open. (Drawer links close it on click.)
  useEffect(() => {
    if (!menuOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [menuOpen]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-dark-bg">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-dvh bg-dark-bg">
      <Sidebar mobileOpen={menuOpen} onMobileClose={() => setMenuOpen(false)} />
      <MobileTopBar onOpenMenu={() => setMenuOpen(true)} />

      <main className={clsx('min-h-dvh transition-[margin] duration-200', sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-56')}>
        {/* Bottom padding clears the mobile tab bar. */}
        <div className="mx-auto max-w-[1360px] px-4 pb-24 pt-5 sm:px-6 lg:px-8 lg:py-7">
          <Outlet />
        </div>
      </main>

      <MobileTabBar onOpenMenu={() => setMenuOpen(true)} />
    </div>
  );
}
